import {
  getAiChatUrl,
  getAuthRedirectUrl,
  getAuthServerUrl,
  getAuthUrl,
  getConsoleUrl,
  getFinanceAnalyticsUrl,
  getGatewayUrl,
  getLiveAnalyticsUrl,
  getLocationSocketUrl,
  getMapAPIKey,
  getNotificationSocketUrl,
} from "./config";

export const consoleUrl = getConsoleUrl();

export const authUrl = getAuthUrl();
export const authServerUrl = getAuthServerUrl();
export const gatewayUrl = getGatewayUrl();

export const locationSocketUrl = getLocationSocketUrl();
export const notificationSocketUrl = getNotificationSocketUrl();

export const financeAnalyticsUrl = getFinanceAnalyticsUrl();
export const liveAnalyticsUrl = getLiveAnalyticsUrl();
export const mapApiKey = getMapAPIKey();

export const aiChatUrl = getAiChatUrl();

export const MAP_TYPES = {
  STATIC: "static",
  LIVE: "live",
  PICK: "pick",
  DISTRIBUTION: "distribution",
};

export const pathColors = {
  1: "blue",
  2: "red",
  3: "lime",
  4: "purple",
  5: "black",
  6: "pink",
  7: "green",
  8: "brown",
  9: "orange",
  10: "yellow",
};

export const geoFenceKeys = {
  MIN_X: "min_x",
  MIN_Y: "min_y",
  MAX_X: "max_x",
  MAX_Y: "max_y",
  CEN_X: "cen_x",
  CEN_Y: "cen_y",
};

export const polylinePathType = {
  PATH: 1,
  ENCODED_PATH: 2,
  ENCODED_PATH_SEGMENT: 3,
};

export const searchFilterConst = {
  CUS: "stakeholder",
  LOC: "destination",
  VEH: "vehicle",
  JOB: "job",
  EVENT_TYPE: "eventType",
  DATE_RANGE: "dateRange",
  JOB_STATUS: "jobStatus",
};

export const searchFilterKeyValue = {
  stakeholder: "Customer",
  destination: "Destination",
  vehicle: "Vehicle",
  job: "Job",
  eventType: "Event Type",
  dateRange: "Date Range",
  jobStatus: "Job Status",
};

export const clientId = "cargotool-web";
export const clientSecret = "Tms@8245";
export const redirectUri = getAuthRedirectUrl();

export const routeService = {
  GOOGLE: 1,
  GRASSHOPPER: 2,
};

export const locationTypes = {
  START: 1,
  END: 2,
  VIA: 3,
};

export const AUTH_TYPES = {
  VIEW: "VIEW",
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
};

export const localStorageKeys = {
  AUTH_TOKEN: "auth_token",
  ACCESS_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  EXPIRES_IN: "expires_in",
  EXPIRE_TIME: "exp",
  TOKEN_TYPE: "token_type",
  EXPIRED_ROUTE: "expired_route",
  AUTH_TIME: "iat",
  CHARGE_LIST_VIEW: "charge_list_view",
  USER: {
    USERNAME: "username",
    AUTHORITIES: "authorities",
    PERMISSIONS: "permissions",
    ROLES: "roles",
    CURRENT_COMPANY: "current_company",
  },
  PREFERENCE: {},
  MAP_SETTINGS: {
    MAP: "map",
  },
};

export const AUTHORITY_TYPE = {
  FIELD: "field",
  FORM: "form",
  MODULE: "module",
};

export const MODULES = {
  Master: "masterdata",
  Transaction: "transport",
  Finance: "finance",
  Auditing: "auditing",
  Fleet: "fleet",
  MIS: "mis",
  Admin: "admin",
  Support: "support",
};

export const SERVICE_ENDPOINT = {
  TRANSPORT: "/transportservice",
  FINANCE: "/financeservice",
  LOCATION: "/locationservice",
  REPORT: "/reportingservice",
  MOBILE: "/mobileservice",
  AUTH: "/authservice",
};

export const STATUS_GROUPS = {
  ALL: "ALL",
  JOB_CHARGE: "JOB-CHARGE",
  STATUS_UPDATE: "STATUS-UPDATE",
  PARTIAL_COMPLETE: "PARTIAL-COMPLETE",
  JOB_CONFIRMATION: "JOB-CONFIRMATION",
  KM_CALCULATION: "KM-CALCULATION",
  OPERATION_COMPLETE: "OPERATION-FINISHED",
  REQUEST_VIEW: "REQUEST-VIEW",
  VEHICLE_ASSIGNMENT_ENABLED: "VEHICLE-ASSIGNMENT-ENABLE",
  VEHICLE_NOT_ASSIGNED: "VEHICLE-NOT-ASSIGNED",
  TIME_UPDATE_ENABLED: "TIME-UPDATE-ENABLED",
  JOB_COMPLETED: "JOB-COMPLETED",
  JOB_DISPUTED: "JOB-DISPUTED",
  AD_HOC_EV_INV: "AD-HOC",
  INTERNAL_STATUS: "INTERNAL-STATUS",
  CUSTOMER_STATUS: "CUSTOMER-STATUS",
  TRANSPORTER_STATUS: "TRANSPORTER-STATUS",
  RELEASE_NOTE_INTERNAL: "RELEASE-NOTE-INTERNAL",
  RELEASE_NOTE_CUSTOMER: "RELEASE-NOTE-CUSTOMER",
  RELEASE_NOTE_TRANSPORTER: "RELEASE-NOTE-TRANSPORTER",
  LOCATION_BASED_RELEASE_NOTE: "LOCATION-BASED-RELEASE-NOTE",
  VEHICLE_ASSIGNMENT_CONTAINER_ENABLED: "VEHICLE-ASSIGNMENT-CONTAINER-ENABLED",
  KM_DEVIATION_ENABLED: "KM-DEVIATION-ENABLED",
  ARRIVAL_CONFIRMATION_ENABLED: "ARRIVAL-CONF-ENABLED",
  ROUTE_CONFIRMATION_ENABLED: "ROUTE-CONF-ENABLED",
  FLAG_ENABLED: "FLAG-ENABLED",
  REMARK_ENABLED: "REMARK-ENABLED",
  CUSTOMER_NEGOTIATION_ENABLED: "CUS-NEGO-ENABLED",
  SUPPLIER_NEGOTIATION_ENABLED: "SUP-NEGO-ENABLED",
  CUSTOMER_NEGOTIATION_ENABLED_AFTER_COMPLETION:
    "CUS-NEGO-POST-COMPLETION-ENABLED",
  SUPPLIER_NEGOTIATION_ENABLED_AFTER_COMPLETION:
    "SUP-NEGO-POST-COMPLETION-ENABLED",
  VEHICLE_REMOVE_ENABLED: "VEHICLE-REMOVE-ENABLE",
  JOB_EDIT_DISABLED: "JOB-EDIT-DISABLED",
  KM_ADDED: "KM_ADDED",
  KM_EDITABLE: "KM-EDITABLE",
  CHARGES_APPLIED: "CHARGES_APPLIED",
  JOB_CBM_EDITABLE: "JOB_CBM_EDITABLE",
  MISSION_CONTROL: "MISSION-CONTROL",
  INTERNAL_USER_PO_NO_EDIT: "INTERNAL_USER_PO_NO_EDIT",
  TRANSPORTER_PO_NO_EDIT: "TRANSPORTER_PO_NO_EDIT",
  CUSTOMER_PO_NO_EDIT: "CUSTOMER_PO_NO_EDIT",
  KM_CALCULATION_ACTION: "KM-CALCULATION-ACTION",
  FOC_ALLOWED: "FOC_ALLOWED",
  CHARGEABLE_KM_UPDATE: "CHARGEABLE-KM-UPDATE",
  FUEL_REQUEST_APPROVAL_ENABLE: "FUEL-REQUEST-APPROVAL-ENABLE"
};

export const SYSTEM_CONFIGS = {
  MISSION_CONTROL_VEHICLE_LIMIT: 17,
  SHIPMENT_STATUS_INVALIDATION_DURATION: 31,
};

export const CONFIGS = {
  AUTO_APPROVAL: "Auto Approval",
  VEHICLE_TRACKING_TIME_GAP: "Vehicle Tracking Time Gap",
  CHARGEABLE_KM: "Chargeable KM",
  PICK_CHARGES_ON_JOB_COMPLETION: "Pick Charges on Job Completion",
  JOB_ON_REQUEST: "JOB On Request",
  JOB_ON_APPROVAL: "Job On Approval",
  UPDATE_FROM_GEO_FENCE: "Update from GEO Fence",
  FMCG_ENABLED: "FMCG Enabled",
  LOCATION_TIME_UPDATE: "Location Time update",
  ROUTE_CONFIRMATION: "Route Confirmation",
  CONSIGNEE_REQUIRED: "Consignee Required",
  MOBILE_NOTIFICATIONS: "Mobile Notifications",
  SYSTEM_NOTIFICATIONS: "System Notifications",
  ALLOW_JOB_OVERLAPPING: "Allow JOB Overlapping",
  TIME_BASED_JOB_OVERLAPPING: "Time Based JOB Overlapping",
  REQUEST_ARRIVAL_TIME_GAP: "Request Arrival time gap",
  ENABLE_RELEASE_NOTE: "Enable Release note",
  VALIDATE_ARRIVAL_CONFIRMATION: "Validate Arrival confirmation",
  REQUEST_AUTO_CANCELLATION: "Request auto cancellation",
  GPS_KM_CALCULATION: "GPS KM calculation",
  REVERSE_KM_CALCULATION: "Reverse KM Calculation",
  POINT_BASE_KM_CALCULATION: "Point Base KM Calculation",
  MANUAL_KM_CALCULATION: "Manual KM calculation",
  AD_HOC_EV_INV: "AD-HOC",
  DEMMURAGE_REASON_MANDATORY: "Demmurage Reason Mandatory",
  RELEASE_NOTE_JOB_AOD_AND_SEAL_CHECK: "Release Note Job AOD and Seal check",
  CTPAT_JOB_AOD_AND_SEAL_CHECK: "Ctpat Job AOD and Seal check",
  REQUEST_CREATION_LOCATION_TIME_GAP: "Request Creation Location Time Gap",
  JOB_CONFIRMATION_ALERT: "Job Confirmation Alert",
};

export const FORMS = {
  GS_DIVISION: {
    GS: { form: "EMPLOYEE", tab: 0 },
    GS_DETAIL: { form: "EMPLOYEE_DETAIL", tab: 1 },
  },
  BANK: {
    BANK_MASTER: { form: "BANK_MASTER", tab: 1 },
  },
  STAKEHOLDER: {
    STK: { form: "STAKEHOLDER", tab: 0 },
    STK_DETAIL: { form: "STAKEHOLDER_DETAIL", tab: 2 },
    TYPE: { form: "STAKEHOLDER_TYPE", tab: 1 },
    CONFIG: { form: "STAKEHOLDER_CONFIG", tab: 7 },
    //CLUSTER: { form: "STAKEHOLDER_CLUSTER", tab: -1 },
    OPERATIONS: { form: "STAKEHOLDER_OPERATION", tab: 5 },
    FINANCE_INFO: { form: "STAKEHOLDER_FINANCE_INFO", tab: 4 },
    CONTACTS: { form: "CONTACTS_1", tab: 3 },
    DOCUMENTS: { form: "DOCUMENTS_1", tab: 8 },
    ALERT: { form: "ALERTS_1", tab: 9 },
    CONSIGNMENT: { form: "STAKEHOLDER_CONSIGNMENT", tab: 6 },
    STK_VEH: { form: "STAKEHOLDER_VEHICLE", tab: 10 },
  },

  TRANSPORTER_INVOICE: {
    INVOICE: { form: "TRANSPORTER_INVOICE", tab: 0 },
    INVOICE_INFO: { form: "TRANSPPORTER_INVOICE_INFO", tab: 1 },
    DOCUMENT: { form: "DOCUMENTS_15", tab: 2 },
  },

  COMMON: {
    CONTACTS: { form: "CONTACTS", tab: 1 },
    DOCUMENTS: { form: "DOCUMENTS", tab: 1 },
    ALERTS: { form: "ALERTS", tab: 1 },
  },
  EMPLOYEE: {
    EMP: { form: "EMPLOYEE", tab: 0 },
    EMP_DETAIL: { form: "EMPLOYEE_DETAIL", tab: 1 },
    EMP_CONTACT: { form: "CONTACTS_9", tab: 2 },
    EMP_DOC: { form: "DOCUMENTS_9", tab: 3 },
    EMP_ALERT: { form: "ALERTS_9", tab: 4 },
    EMP_STATUS: { form: "EMPLOYEE_STATUS_CHANGE", tab: 0 },
  },
  VEHICLE: {
    VEH: { form: "VEHICLE", tab: 0 },
    VEH_DETAIL: { form: "VEHICLE_DETAIL", tab: 1 },
    OPERATIONS: { form: "VEHICLE_OPERATION", tab: 2 },
    TYPE: { form: "VEHICLE_TYPE", tab: 3 },
    CHECKUP: { form: "VEHICLE_CHECKUP", tab: 4 },
    BREAKDOWN: { form: "VEHICLE_BREAKDOWN", tab: 6 },
    DOCUMENT: { form: "DOCUMENTS_4", tab: 5 },
    VEH_STATUS: { form: "VEHICLE_STATUS_CHANGE", tab: 0 },
  },
  TRAILERS: {
    TRL: { form: "TRAILERS", tab: 0 },
    TRL_DETAIL: { form: "TRAILERS_DETAIL", tab: 1 },
  },
  POLICE_DIVISION: {
    POL: { form: "POLICE_DIVISION", tab: 0 },
    POL_DETAIL: { form: "POLICE_DIVISION_DETAIL", tab: 1 },
  },
  BANK_BRANCH: {
    BNK_BRN: { form: "BANK_BRANCH", tab: 0 },
    BNK_BRN_DETAIL: { form: "BANK_BRANCH_DETAIL", tab: 1 },
  },
  AGREEMENT: {
    AGR: { form: "AGREEMENTS", tab: 0 },
    AGR_DETAIL: { form: "AGREEMENT_DETAIL", tab: 1 },
    AGR_DOCUMENT: { form: "DOCUMENTS_6", tab: 2 },
  },
  AGREEMENT_TEMPLATE: {
    TEM: { form: "AGREEMENT_TEMPLATE", tab: 0 },
    TEM_DETAIL: { form: "AGREEMENT_TEMPLATE_DETAIL", tab: 1 },
    PREVIEW: { form: "AGREEMENT_TEMPLATE_PREVIEW", tab: 2 },
  },
  LOCATION: {
    LOC: { form: "LOCATION", tab: 0 },
    LOC_DETAIL: { form: "LOCATION_DETAIL", tab: 1 },
    LOC_CONTACTS: { form: "CONTACTS_5", tab: 2 },
    LOC_CUSTOMER: { form: "LOCATION_CUSTOMER", tab: 3 },
    LOC_PROVIDER: { form: "LOCATION_PROVIDER", tab: 4 },
  },
  LOCATION_APPROVAL: {
    LOC_APP: { form: "LOCATION_APPROVAL", tab: 0 },
  },
  GEO_MANAGER: {
    GEO: { form: "GEO_MANAGER", tab: 0 },
  },
  ITEM: {
    TEM: { form: "ITEM", tab: 1 },
    APPROVAL: { form: "APPROVAL", tab: 1 },
  },
  CLUSTER: {
    CLU: { form: "CLUSTER", tab: 0 },
    CLU_DETAIL: { form: "CLUSTER_DETAIL", tab: 1 },
    CLU_ALERT: { form: "ALERTS_2", tab: 2 },
  },
  STAKEHOLDER_GROUP: {
    GRP: { form: "STAKEHOLDER_GROUP", tab: 0 },
    GRP_DETAIL: { form: "STAKEHOLDER_GROUP_DETAIL", tab: 1 },
  },
  BLACKLIST: {
    BLK: { form: "BLACKLIST", tab: 0 },
    BLK_DETAIL: { form: "BLACKLIST_DETAIL", tab: 1 },
    BLK_DOCUMENT: { form: "DOCUMENTS_11", tab: 2 },
  },

  CALL_CENTER_SHIFT: {
    SHI: { form: "SHIFT", tab: 0 },
    SHIFT: { form: "SHIFT_DETAIL", tab: 1 },
    SHIFT_USER: { form: "SHIFT_USER", tab: 2 },
    SHIFT_ACTION: { form: "SHIFT_ACTION", tab: 3 },
  },
  CALL_CENTER_SHIFT_GROUP: {
    SHF_G: { form: "SHIFT_GROUP", tab: 0 },
    SHIFT_GROUP: { form: "SHIFT_GROUP_DETAIL", tab: 1 },
    SHIFT_STK: { form: "SHIFT_GROUP_STK", tab: 2 },
    // SHIFT_USER: {form: "SHIFT_GROUP_USER", tab: 3},
  },
  CALL_CENTER_SHIFT_ASSIGNMENT: {
    SFH: { form: "SHIFT_ASSIGN", tab: 0 },
    SHIFT_ASSIGN: { form: "SHIFT_ASSIGNMENT", tab: 1 },
    SHIFT_STK: { form: "SHIFT_ASSIGN_STK", tab: 2 },
    SHIFT_USER: { form: "SHIFT_ASSIGN_USER", tab: 3 },
  },

  REQUEST: {
    COPY: { form: "REQUEST_COPY", tab: 0 },
    CREATION: { form: "REQUEST_CREATION", tab: 0 },
    CREATION_INFO: { form: "REQUEST_CREATION_INFO", tab: 1 },
    TRANSPORT: { form: "REQUEST_TRANSPORT", tab: 2 },
    LOCATION: { form: "REQUEST_LOCATION", tab: 3 },
    START_LOCATION: { form: "REQUEST_START_LOCATION", tab: 0 },
    END_LOCATION: { form: "REQUEST_END_LOCATION", tab: 0 },
    VIA_LOCATION: { form: "REQUEST_VIA_LOCATION", tab: 0 },
    CONSIGNEE: { form: "REQUEST_CONSIGNEE", tab: 0 },
    SUMMARY: { form: "REQUEST_SUMMARY", tab: 4 },
    OTHER: { form: "REQUEST_OTHER", tab: 5 },
    DOCUMENT: { form: "DOCUMENTS_7", tab: 6 },
    REQUEST_SAVE_APPROVE: { form: "REQUEST_SAVE_APPROVE", tab: 0 },
  },
  QUICK_REQUEST: {
    CREATION: { form: "QUICK_REQUEST_CREATION", tab: 0 },
    CREATION_INFO: { form: "QUICK_REQUEST_CREATION_INFO", tab: 0 },
    TRANSPORT: { form: "QUICK_REQUEST_TRANSPORT", tab: 0 },
    LOCATION: { form: "QUICK_REQUEST_LOCATION", tab: 0 },
    CONSIGNEE: { form: "QUICK_REQUEST_CONSIGNEE", tab: 0 },
    SUMMARY: { form: "QUICK_REQUEST_SUMMARY", tab: 0 },
    OTHER: { form: "QUICK_REQUEST_OTHER", tab: 0 },
  },
  REQUEST_APPROVAL: {
    APPROVAL: { form: "REQUEST_APPROVAL", tab: 1 },
  },
  FUEL_REQUEST: {
    HEADER: { form: "FUEL_REQUEST", tab: 0 },
    DETAILS: { form: "FUEL_REQUEST_DETAIL", tab: 1 },
    APPROVE: { form: "FUEL_REQUEST_APPROVE", tab: 2 },
    PUMPER: { form: "FUEL_REQUEST_PUMPER", tab: 3 },
  },
  DISTRIBUTION_CREATION: {
    CREATION: {
      form: "DISTRIBUTION_CREATION",
    },
  },
  DISTRIBUTION_MANAGE: {
    MANAGE: {
      form: "DISTRIBUTION_MANAGE",
    },
  },
  JOB: {
    MONITOR: { form: "JOB_MONITORING", tab: 1 },
    NEGOTIATION: { form: "JOB_NEGOTIATION", tab: 1 },
    FLAG: { form: "JOB_FLAG", tab: 1 },
    VEHICLE: { form: "VEHICLE_ASSIGNMENT", tab: 1 },
    TIME_UPDATE: { form: "TIME_UPDATE", tab: 1 },
    TRACK: { form: "GPS_TRACKING", tab: 1 },
    DOCUMENT: { form: "DOCUMENTS_8", tab: 1 },
    CONFIMATION: { form: "JOB_CONFIMATION", tab: 1 },
    DED_FUEL: { form: "ADD_FUEL", tab: 1 },
    REPORT: { form: "JOB_REPORT", tab: 1 },
    TENTATIVE_CONFIRMED_REPORT: { form: "TENTATIVE_CONFIRMED_REPORT", tab: 1 },
    JOB_COMPLETED_NEGOTIATION: { form: "JOB_COMPELETED_NEGOTIATION", tab: 1 },
    KM_DEVIATION_UPDATE: { form: "KM_DEVIATION_UPDATE", tab: 1 },
    LIVE_TRACK_OPTION: { form: "LIVE_TRACK_OPTION", tab: 1 },
  },
  APPROVAL: {
    SUPPLIER_NEGOTIATION: { form: "SUPPLIER_NEGOTIATION_APPROVAL", tab: 1 },
  },
  MIS: {
    REPORT: { form: "MIS_REPORT", tab: 0 },
    AUDIT_REPORT: { form: "AUDIT_REPORT", tab: 0 },
    REVENUE_DISTRIBUTION_REPORT: {
      form: "REVENUE_DISTRIBUTION_REPORT",
      tab: 0,
    },
    PERFORMANCE_FINANCE_REPORT: { form: "PERFORMANCE_FINANCE_REPORT", tab: 0 },
    PERFORMANCE_MONITOR: { form: "PERFORMANCE_MONITOR", tab: 0 },
    VEHICLE_IN_AND_OUT: { form: "VEHICLE_IN_AND_OUT", tab: 0 },
    DOCUMENT_DELIVERY_NOTE: { form: "DOCUMENT_DELIVERY_NOTE", tab: 0 },
    CALL_CENTER_PERFORMANCE: { form: "CALL_CENTER_PERFORMANCE", tab: 0 },
    DEDUCTION_REPORT: { form: "DEDUCTION_REPORT", tab: 0 },
    REPORT_GENERATOR: { form: "REPORT_GENERATOR", tab: 0 },
    METABASE_FINANCE_ANALYTICS: { form: "FINANCE_ANALYTICS", tab: 0 },
    METABASE_LIVE_ANALYTICS: { form: "LIVE_ANALYTICS", tab: 0 },
    RULE_CREATION: { form: "RULE_CREATION", tab: 0 },
  },
  REVIEW: {
    CHARGE: { form: "REVIEW_CHARGE_APPROVE", tab: 0 },
  },

  JOB_STATUS: {
    HISTORY: { form: "JOB_STATUS_HISTORY", tab: 1 },
    MANAGER: { form: "JOB_STATUS_MANAGER", tab: 2 },
  },
  VEHICLE_ASSIGNMENT: {
    VEHICLE: { form: "VEHICLE_ASSIGNMENT", tab: 1 },
    CONTAINER: { form: "VEHICLE_ASSIGNMENT_CONTAINER", tab: 2 },
  },
  EXCHANGE_RATE: {
    EXC: { form: "EXCHANGE_RATE", tab: 0 },
    EXC_DETAIL: { form: "EXCHANGE_RATE_DETAIL", tab: 1 },
  },
  RATE_MANAGER: {
    HEADER: { form: "RATE_MANAGER", tab: 1 },
    DETAILS: { form: "RATE_DETAILS", tab: 1 },
    LOCATIONS: { form: "RATE_LOCATION", tab: 1 },
  },
  CHARGE_CREATION: {
    HEADER: { form: "CHARGE_CREATION", tab: 1 },
    DETAILS: { form: "CHARGES", tab: 1 },
    CHARGE_BULK_UPLOAD: { form: "CHARGE_BULK_UPLOAD", tab: 2 },
  },
  CHARGE_APPROVAL: {
    HEADER: { form: "CHARGE_APPROVAL", tab: 0 },
    DETAILS: { form: "CHARGE_APPROVAL_DETAIL", tab: 0 },
    DOCUMENT: { form: "DOCUMENTS_10", tab: 0 },
  },
  EV_INV_MANAGER: {
    HEADER: { form: "EV_INV", tab: 0 },
    DETAILS: { form: "EV_INV_DETAIL", tab: 0 },
  },
  SUPPLIER_PAYMENT_HOLD: {
    HEADER: { form: "SUPPLIER_PAYMENT_HOLD", tab: 0 },
    DETAILS: { form: "SUPPLIER_PAYMENT_DETAIL", tab: 0 },
  },
  EV_INV_APPROVAL: {
    HEADER: { form: "EV_INV_APPROVAL", tab: 0 },
    DETAILS: { form: "EV_INV_APPROVAL_DETAIL", tab: 0 },
  },
  TAX_MANAGER: {
    HEADER: { form: "TAX_SETUP", tab: 1 },
    DETAILS: { form: "TAX_DETAIL", tab: 2 },
  },
  CREDIT_DEBIT: {
    HEADER: { form: "CREDIT_DEBIT", tab: 0 },
    CD_EV_INV: { form: "CREDIT_DEBIT_EV_INV", tab: 1 },
    CD_DRAFT: { form: "CREDIT_DEBIT_DRAFT", tab: 2 },
    CD_NOTE: { form: "CREDIT_DEBIT_NOTE", tab: 3 },
  },
  MISSION_CONTROL: {
    MC: { form: "MISSION_CONTROL", tab: 1 },
  },
  APPROVAL_MANAGER: {
    APPROVAL_MANAGER: "APPROVAL_MANAGER",
    DEDUCTION_MANAGER: "DEDUCTION_MANAGER",
  },
  DEDUCTION: {
    DEDUCTION_MASTER: { form: "DEDUCTION_MASTER", tab: 1 },
    DEDUCTION_BULK_UPLOAD: { form: "DEDUCTION_BULK_UPLOAD", tab: 2 },
  },
  NCR: {
    UPLOAD: "NCR_FORM",
    // UPLOAD: { form: "NCR_FORM", tab: 0 },
    GENERAL: { form: "GENERAL_INFO", tab: 1 },
    DOCUMENT: { form: "DOCUMENTS_12", tab: 2 },
  },
  FLEET_DASHBORARD: {
    DASHBORARD: { form: "FLEET_DASHBORARD", tab: 0 },
  },
  TEMPLATE: {
    DYNAMIC_TEM: { form: "DYNAMIC_TEMPLATE", tab: 0 },
    TEM: { form: "TEMPLATE_DETAILS", tab: 1 },
    FIELD: { form: "TEMPLATE_FIELD", tab: 2 },
    FIELD_ALERT: { form: "ALERTS_16", tab: 3 },
  },
  FLEET: {
    DOCUMENT_MANAGEMENT: { form: "FLEET_DOCUMENT_MANAGEMENT", tab: 0 },
    INFO: { form: "MANAGE_INFO", tab: 1 },
    DOCUMENT: { form: "DOCUMENTS_15", tab: 2 },
  },
  FLEET_UPDATE: {
    DOCUMENT_MANAGEMENT: { form: "FLEET_DOCUMENT_MANAGEMENT", tab: 0 },
    INFO: { form: "MANAGE_INFO", tab: 1 },
    DOCUMENT: { form: "DOCUMENTS_15", tab: 2 },
    COST: { form: "MANAGE_COST", tab: 3 },
  },
  FLEET_INSPECTION: {
    INSPECTION_PROCESS: { form: "FLEET_INSPECTION_PROCESS", tab: 0 },
    INFO: { form: "MANAGE_INSPECTION_INFO", tab: 1 },
    DOCUMENT: { form: "DOCUMENTS_16", tab: 2 },
  },
  FLEET_INSPECTION_UPDATE: {
    INSPECTION_PROCESS: { form: "FLEET_INSPECTION_PROCESS", tab: 0 },
    INFO: { form: "MANAGE_INSPECTION_INFO", tab: 1 },
    DOCUMENT: { form: "DOCUMENTS_16", tab: 2 },
    COST: { form: "MANAGE_INSPECTION_COST", tab: 3 },
  },
  FLEET_ISSUE: {
    ISSUE_MANAGEMENT: { form: "FLEET_ISSUE_MANAGEMENT", tab: 0 },
    INFO: { form: "MANAGE_ISSUE_INFO", tab: 1 },
  },
  FLEET_WORK_ORDER: {
    WORK_ORDER: { form: "FLEET_WORK_ORDER", tab: 0 },
    INFO: { form: "WORK_ORDER_INFO", tab: 1 },
    DOCUMENT: { form: "DOCUMENTS_31", tab: 2 },
    CLOSED: { form: "FLEET_WORK_ORDER_FORM_CLOSED", tab: 1 },
    OPEN: { form: "OPEN", tab: 1 },
    INPROGRESS: { form: "INPROGRESS", tab: 1 },
    OVERDUE: { form: "OVERDUE", tab: 1 },
    RESOLVED: { form: "RESOLVED", tab: 1 },
    ONHOLD: { form: "ONHOLD", tab: 1 },
  },
  ALERTS: {
    ALR: { form: "ALERTS", tab: 0 },
    ALR_DETAIL: { form: "ALERTS_DETAIL", tab: 1 },
  },
  MAIN_DASHBOARD: {
    DASHBOARD: { form: "MAIN_DASHBOARD", tab: 0 },
    TRANSPORTER_DASHBOARD: { form: "TRANSPORTER_DASHBOARD", tab: 0 },
    TRANSPORTER_PANEL: { form: "TRANSPORTER_PANEL", tab: 0 },
    FLEET_MAIN_PANEL: { form: "FLEET_MAIN_PANEL", tab: 0 },
  },
  DEVICE_MANAGER: {
    REGISTER_DEVICE: { form: "REGISTER_DEVICE", tab: 0 },
  },
  HELP_CENTER: {
    HELP_CENTER: { form: "HELP_CENTER", tab: 0 },
    INFO: { form: "MANAGE_INFO", tab: 1 },
    DOCUMENT: { form: "DOCUMENTS_25", tab: 2 },
    RELEASE_NOTE: { form: "RELEASE_NOTE", tab: 0 },
    RELEASE_NOTE_POPUP: { form: "RELEASE_NOTE_POPUP", tab: 0 },
  },
  ACTION_CENTER: {
    ACTION_CENTER: { form: "ACTION_CENTER", tab: 0 },
    NOTIFICATION: { form: "NOTIFICATION", tab: 0 },
  },
  OUTBOX: {
    OUTBOX: { form: "OUTBOX", tab: 0 },
  },
  CUSTOMER_FILTER: {
    FILTER: { form: "CUSTOMER_FILTER", tab: 0 },
  },
  ORACLE_PROCESS_QUEUE: {
    ORACLE_PROCESS_QUEUE: { form: "ORACLE_PROCESS_QUEUE", tab: 0 },
  },
  OPTION_CONFIG: {
    OPT: { form: "OPTION_CONFIG", tab: 0 },
    OPT_DETAIL: { form: "OPTION_DETAIL", tab: 1 },
  },
  SUPPORT: {
    SUPPORT_FEATURE: { form: "SUPPORT_FEATURE", tab: 0 },
    JOB_MODIFICATION: { form: "JOB_MODIFICATION", tab: 1 },
    FINANCE_AMENDMENT: { form: "FINANCE_AMENDMENT", tab: 2 },
    EMPLOYEE_MODIFICATION: { form: "EMPLOYEE_MODIFICATION", tab: 3 },
    VEHICLE_MODIFICATION: { form: "VEHICLE_MODIFICATION", tab: 4 },
  },
  JOB_MODIFICATION: {
    BILLING_CUSTOMER: { form: "BILLING_CUSTOMER_MODIFICATION", tab: 0 },
    INVOICING_CUSTOMER: { form: "INVOICING_CUSTOMER_MODIFICATION", tab: 0 },
    OPERATION_REMARK: { form: "OPERATION_REMARK_MODIFICATION", tab: 0 },
    CREATOR_REMARK: { form: "CREATOR_REMARK_MODIFICATION", tab: 0 },
    PLANT: { form: "PLANT_MODIFICATION", tab: 0 },
    REQUEST_ARRIVAL: { form: "REQUEST_ARRIVAL_MODIFICATION", tab: 0 },
    VEHICLE: { form: "VEHICLE_MODIFICATION", tab: 0 },
    DELIVERY_CUTOFF: { form: "DELIVERY_CUTOFF_MODIFICATION", tab: 0 },
    REQUEST_OTHER: { form: "REQUEST_OTHER_MODIFICATION", tab: 0 },
    CHARGEABLE_KM: { form: "CHARGEABLE_KM_MODIFICATION", tab: 0 },
  },
  FINANCE_AMENDMENT: {
    CHARGE_REMOVAL: { form: "FINANCE_CHARGE_REMOVAL", tab: 0 },
  },
  EMPLOYEE_MODIFICATION: {
    UPDATE_DATE: { form: "EMPLOYEE_UPDATE_DATE", tab: 0 },
  },
  VEHICLE_MODIFICATION: {
    VEHICLE_CHECKUP_DATE: { form: "VEHICLE_CHECKUP_DATE", tab: 0 },
  },

  TRANSPORTER_DASHBOARD: {
    VEHICLE_SUMMARY_DASHBOARD: { form: "VEHICLE_SUMMARY_DASHBOARD", tab: 0 },
    JOB_TREND_DASHBOARD: { form: "JOB_TREND_DASHBOARD", tab: 0 },
    JOB_STATUS_DASHBOARD: { form: "JOB_STATUS_DASHBOARD", tab: 0 },
    CHARGEABLE_DASHBOARD: { form: "CHARGEABLE_DASHBOARD", tab: 0 },
    REVENUE_DASHBOARD: { form: "REVENUE_DASHBOARD", tab: 0 },
    VEHICLE_TYPE_DASHBOARD: { form: "VEHICLE_TYPE_DASHBOARD", tab: 0 },
  },
};

export const authErrors = {
  INVALID_GRANT: "invalid_grant",
};

// Job Monitor
export const gridHeaders = {
  REQUEST_COPY: "Request Copy",
  REPORT_TYPE: "Report Type Selection",
  SUPPLER_NEGO: "Supplier Negotiation Form",
  CUSTOMER_NEGO: "Customer Negotiation Form",
  JOB_APPROVAL: "Job Confirmation Form",
  FLAG: "Flag Form",
  REMARKS: "Remarks Form",
  VEHICLE_INFO: "Vehicle Information",
  STATUS: "Job Status",
  VEHICLE_STATUS: "Vehicle Status",
  REQUEST: "Request No",
  JOB: "Request No",
  DOCUMENT: "Upload",
  TIME_UPDATE: "Time Update",
  KM_ACTUAL: "KM Actual",
  DED_FUEL: "Fuel Quota",
  COLUMN_CONFIG: "Column Config",
  DISPUTE_RESOLUTION: "DISPUTE_RESOLUTION",
  LIVE_TRACK_LINK: "Live Track Link",
  E_SEAL_ASSIGN:"E-Seal",
  E_SEAL_UNLOCK:"E-Seal Unlock",
  E_SEAL_LOCK:"E-Seal Lock"
};

export const PINNED_COLUMN_COLOR = "#fcfcfe";

export const inputFieldProfile = {
  TEXT: "TEXT",
  DECIMAL: "DECIMAL",
};

export const statusConst = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
  IDLE: "IDLE",
  INIT: "INIT",
};

export const errorconst = {
  401: "Invalid Credentials",
};

export const gridColors = {
  active: {
    active: "#5AC68D",
    deleted: "#FF8A80",
  },
  status: {
    pending: "#FFD54F",
    approved: "#5AC68D",
    rejected: "#FF8A80",
  },
};

export const statusById = {
  1: "Pending",
  2: "Approved",
  3: "Rejected",
};

export const activeById = {
  1: "Active",
  2: "Deleted",
};

export const searchTagConst = {
  vehicle: {
    CREATE: "#create",
    VEHICLE: "#vehicle",
    VEHICLE_DOCS: "#vehicle-docs",
    VEHICLE_TYPES: "#vehicle-types",
    VEHICLE_CONFIG: "#vehicle-configs",
    VEHICLE_OPERATIONS: "#vehicle-operations",
    VEHICLE_CHECKUP: "#vehicle-checkups",
  },
};

export const speedColor = {
  HIGH: "#FF6347",
  MEDIUM: "#FF00FF",
  LOW: "#007bff",
  STATIONARY: "#BBBBBBFF",
};

export const inTimeColors = {
  IN_TIME: "#26921D",
  LATE: "#FF6347",
};

export const pathToModuleNameAndDescriptionMap = {
  "/login": { moduleName: "Login", description: "This is login form" },
  "/form": { moduleName: "Form", description: "This is a form" },
  "/": { moduleName: "Dashboard", description: "This is the dashboard" },
  "/grid": { moduleName: "Grid", description: "This is the grid" },
  "/charts": { moduleName: "Chart", description: "This is the charts page" },
  "/formex": { moduleName: "Formex", description: "This is a form" },
  "/example/wizard": {
    moduleName: "Wizard",
    description: "This is the wizard",
  },
  "/mission-control": {
    moduleName: "Vehicle",
    description: "This is the vehicle screen",
  },
  "/master/gs-division": {
    moduleName: "Grama Niladhari Division",
    description: "Create and Manage Grama Niladhari Divisions",
  },
  "/master/vehicle": {
    moduleName: "Vehicle",
    description: "Create and Manage Vehicles",
  },
  "/master/vehicle-type": {
    moduleName: "Vehicle Type",
    description: "Create and Manage Vehicle Types",
  },
  "/master/location-creation": {
    moduleName: "Location Creation",
    description: "Create and Manage Locations ",
  },
  "/master/location-approval": {
    moduleName: "Location Approval",
    description: "Approve Locations ",
  },
  "/master/stakeholder": {
    moduleName: "Stakeholder",
    description: "Create and Manage Stakeholders",
  },
  "/master/trailers": {
    moduleName: "Trailers",
    description: "This is the Trailers",
  },
  "/master/police-division": {
    moduleName: "Police Division",
    description: "Create and Manage Police Divisions",
  },
  "/master/bank-branch": {
    moduleName: "Bank Branch",
    description: "Create and Manage Bank Branches",
  },
  "/master/agreements": {
    moduleName: "Agreement",
    description: "Manage Agreement Details",
  },
  "/master/agreement-template": {
    moduleName: "Agreement Template",
    description: "Create, update, delete and render agreement templates",
  },
  "/master/employee": {
    moduleName: "Employee",
    description: "Create and Manage Employees",
  },
  "/master/blacklist": {
    moduleName: "Black List",
    description: "Add and Manage restricted Vehicle/Employees",
  },
  "/master/location-provider": {
    moduleName: "Location Provider",
    description: "This is the Location Provider",
  },
  "/fleet/template-create": {
    moduleName: "Dynamic Template",
    description: "Create and customize templates",
  },

  "/finance/exchangeRate": {
    moduleName: "Exchange Rate",
    description: "Set currency exchange rates",
  },
  "/finance/rate-manager": {
    moduleName: "Rate Master",
    description: "Define and manage rate details",
  },
  "/finance/charge": {
    moduleName: "Charge Creation",
    description: "Define charges For revenue or cost",
  },
  "/finance/oracle-process-queue": {
    moduleName: "Oracle Process Queue",
    description: "This is the Oracle Process Queue",
  },
  "/transaction/request-creation": {
    moduleName: "Request Creation",
    description: "Create Requests for Transportation",
  },
  "/master/cluster-creation": {
    moduleName: "Cluster",
    description: "Create and Manage Clusters",
  },
  "/master/stakeholder-group-creation": {
    moduleName: "Stakeholder Group",
    description: "Create Stakeholders in to groups",
  },
  "/transaction/request-creation-new": {
    moduleName: "Request Creation",
    description: "This is the request creation",
  },
  "/transaction/job-monitoring": {
    moduleName: "Job Monitoring",
    description: "Track and Manage  jobs in real-time",
  },
  "/master/vehicle-assignment": {
    moduleName: "Vehicle Assignment",
    description: "This is the Vehicle Assignment page",
  },
  "/transaction/request-approval": {
    moduleName: "Request Approval",
    description: "Approval of the Requests",
  },
  "/transaction/ncr-upload": {
    moduleName: "NCR Upload",
    description: "Upload and Manage NCR  files",
  },
  "/finance/inv-ev": {
    moduleName: "Inv-Ev",
    description: "This is the Inv-Ev",
  },
  "/finance/charge-confirmation": {
    moduleName: "Charge Approval",
    description: "	Approval of the Charges",
  },
  "/finance/ev-inv-generator": {
    moduleName: "EV/INV Manager",
    description: "Create and Manage expense vouchers and invoices",
  },
  "/finance/supplier-payment-hold": {
    moduleName: "Payment Hold",
    description: "Payment holds supplier wise and job wise",
  },
  "/finance/ev-inv-approve": {
    moduleName: "EV/INV Approval",
    description: "This screen is used to approve EV/INV",
  },
  "/finance/invoice-search": {
    moduleName: "Invoice Search",
    description: "This screen is used to search invoices",
  },
  "/finance/tax-management": {
    moduleName: "Tax Management",
    description: "Set and maintain tax rates",
  },
  "/finance/charge-type": {
    moduleName: "Charge Type",
    description: "Add a Tax Type against to a Charge Type",
  },
  "/finance/approvalProcess": {
    moduleName: "Approval Process",
    description: "This screen is used to approvals",
  },
  "/finance/deduction-master": {
    moduleName: "Deduction Creation",
    description: "Create and Manage  deductions",
  },
  "/master/item-creation": {
    moduleName: "Item Creation",
    description: "Add > Item Creation",
  },
  "/finance/credit-debit-note": {
    moduleName: "Credit/Debit Note",
    description: "Create and Manage Credit/Debit Notes",
  },
  "/master/deduction-approval": {
    moduleName: "Approval Master",
    description: "Manage all the Approvals",
  },
  "/fleet/document-management": {
    moduleName: "Document Management",
    description: "Upload and manage documents for inspections",
  },
  "/fleet/fleet-dashboard": {
    moduleName: "Fleet Dashboard",
    description: "This is the fleet dashboard overview",
  },
  "/fleet/inspection-process": {
    moduleName: "Inspections",
    description: "Perform inspections for the vehicles",
  },
  "/fleet/issues": {
    moduleName: "Issue Management",
    description: "Handle and track issues for vehicles",
  },
  "/fleet/work-order": {
    moduleName: "Work Order",
    description: "Perform work order",
  },
  "/fleet/inspection-create": {
    moduleName: "Inspections by Template",
    description: "Create inspections directly by favourite templates",
  },
  "/master/geographical-management": {
    moduleName: "Geo Manager",
    description: "Create and Manage Regions, Countries, States",
  },
  "/mis/mis-report": {
    moduleName: "MIS Report",
    description: "This screen is used to generate MIS Reports",
  },
  "/mis/performance-monitor": {
    moduleName: "Performance Monitor",
    description: "This screen is used to generate Performance Monitor Reports",
  },
  "/mis/vehicle-in-out": {
    moduleName: "Vehicle In and Out",
    description: "This screen is used to generate Vehicle In and Out reports",
  },
  "/mis/document-delivery-note": {
    moduleName: "Document Delivery Note",
    description:
      "This screen is used to generate Document Delivery Note reports",
  },
  "/mis/call-center-performance": {
    moduleName: "Call Center Performance",
    description:
      "This screen is used to generate Call Center Performance reports",
  },
  "/master/call-center-shift": {
    moduleName: "Call Center Shift",
    description: "This screen is Shift screen",
  },
  "/master/call-center-shift-group": {
    moduleName: "Call Center Shift Group",
    description: "This screen is Shift Group screen",
  },

  "/transaction/call-center-shift": {
    moduleName: "Call Center Shift Assignment",
    description: "This screen is Shift Assignment screen",
  },

  "/audit/audit-report": {
    moduleName: "Audit Report",
    description: "This screen is used to generate Audit Reports",
  },

  "/transaction/approval/supplier-negotiation": {
    moduleName: "Supplier Negotiation Approval",
    description: "Approve and reject supplier negotiations",
  },

  "/transaction/fuel-request-panel": {
    moduleName: "Fuel Request Panel",
    description: "Fuel request panel",
  },

  "/mis/finance-analytics": {
    moduleName: "Financial Analytics",
    description: "Finance Analytics New TMS Dashboard",
  },

  "/mis/live-analytics": {
    moduleName: "Live Analytics",
    description: "Live Analytics New TMS Dashboard",
  },

  unauthorized: {
    moduleName: "Approval Master",
    description: "This screen is used to add approvals",
  },

  "/revenue/revenue-report": {
    moduleName: "Revenue Distribution Report",
    description: "This screen is used to generate revenue reports",
  },

  "/performance/finance-report": {
    moduleName: "Performance Finance Report",
    description: "This screen is used to generate performance finance reports",
  },

  "/admin/option-config": {
    moduleName: "Option Config ",
    description: "This screen is used to create option configs",
  },
  "/mis/deduction": {
    moduleName: "Deduction Report",
    description: "This screen is used to generate Deduction reports",
  },
  "/finance/transporter-invoice": {
    moduleName: "Transporter Invoice",
    description: "This screen is used to generate Transporter invoice",
  },
  "/admin/default-alert": {
    moduleName: "Alert",
    description: "This screen is used to create default alerts",
  },
  "/mis/report-generator": {
    moduleName: "Report Generator",
    description: "This screen is used to generate reports",
  },
  "/mis/report-generator/queue": {
    moduleName: "Report Generator",
    description: "This screen is used to generate reports",
  },
  "/mis/report-generator/queue/:id": {
    moduleName: "Report Generator",
    description: "This screen is used to generate reports",
  },
  "/support/job-modification": {
    moduleName: "Job Modification",
    description: "This screen is used to Modify Jobs",
  },
  "/support/finance-amendment": {
    moduleName: "Finance Amendment",
    description: "This screen is used to remove charges",
  },

  "/mis/report-generator/rule-creation": {
    moduleName: "Report Generator",
    description: "This screen is used to create rules",
  },
  "/support/employee-modification": {
    moduleName: "Employee Modification",
    description: "This screen is used to modify employees",
  },
  "/support/vehicle-modification": {
    moduleName: "Vehicle Modification",
    description: "This screen is used to modify vehicle",
  },
};

export const dropdownKeysAndValues = {
  DRIVER: { type: "employee", value: "Driver" },
  HELPER: { type: "employee", value: "Helper" },
  TRAVELLER: { type: "employee", value: "Traveler" },
};

// TODO Make Column config more developer friendly when doing changes.

export const jobMonitorHeaderList = {
  gReqCode: "Request Id",
  gJobCode: "Job No",
  // jobCreatedBy: "Job Created By",
  creatorRemark: "Creator Remark",
  gReqCustomer: "Customer",
  gReqInvoicingCustomer: "Invoicing Customer",
  gReqPlant: "Requesting Plant",
  gJobTransporter: "Transporter",
  conMobile: "Transporter Contact",
  gJobVehicle: "Vehicle",
  gDriverName: "Driver Name",
  // gDrvLicenceNo: "Driver License",
  gHelperName: "Helper Name",
  jobVehAssignRemark: "Job Veh Assign Remark",
  vehicleAssignedBy: "Assigned By",
  vehicleAssignedDate: "Assigned Date",
  arrivalConfirmation: "Arrival Confirmation",
  gLatestFlag: "Flags",
  supplierNego: "Supplier Negotiations",
  customerNego: "Customer Negotiations",
  gVhtType: "Vehicle Type",
  otherCharges: "Other Requests",
  shipmentType: "Shipment Type",
  consignmentType: "Consignment Type",
  consignee: "Consignee",
  reqKagNoValue: "KAG Number",
  startLocation: "Start Location",
  gFirstArrivalTime: "ARRD At Pickup Point",
  endLocation: "End Location",
  gLastArrivalTime: "ARRD At Delivery Point",
  gReqBookingApprovedBy: "Approved By",
  gReqBookingApprovalDate: "Shipment Approval Time",
  reference: "Reference",
  gReqBillingCustomer: "Billing Customer",
  reqLateAccept: "Late Accept",
  reqLateBooking: "Late Booking",
  gCreatedDate: "Date Created",
  gCreatedBy: "Shipment Creator",
  // jobCreatedDate: "Job Created Date",
  behalfOfUser: "Behalf Of",
  gDrvPhoneNo: "Driver Phone",
  driverNic: "Driver NIC",
  gHelNicNo: "Helper NIC",
  gHelPhoneNo: "Helper Phone",
  reqPoNo: "Req PO No",
  jobAod: "Job Aod",
  jobCallCenterRemark: "Monitoring center remarks",
  jobOtdRemark: "OTD  remarks",
  jobSeal1: "Job Seal 1",
  jobSeal2: "Job Seal 2",
  jobSeal3: "Job Seal 3",
  jobESeal: "E-Seal",
  jobMoux: "Job Moux",
  jobCarton: "Job Carton",
  jobOperationRemark: "Job Operation Remark",
  jobCustomerFeedback: "Job Customer Feedback",
  jobHeldUpRemark: "Job Held Up Remark",
  routeConfirmation: "Route Confirmation",
  kmDeviation: "KM Deviation",
  gLatestRemark: "Remarks",
  gFirstDepatureTime: "DEP From Pickup point",
  gArrOnTime: "Arrival On Time",
  gLastDepatureTime: "DEP From Delivery Point",
  gDepOnTime: "Depature On Time",
  // arrivalEta: "Start Location ETA",
  arrivalEta: "Requested Arrival Time",
  deliveryEta: "Requested Delivery Time",
  // deliveryEta: "End Location ETA",

  // startTimeGap: "Start Time Gap",
  // startArrTimeUpdatedBy: "Updated By",
  // startDepTimeUpdatedBy: "Updated By",
  // endTimeGap: "End Time Gap",
  // endArrTimeUpdatedBy: "Updated By",
  // endDepTimeUpdatedBy: "Updated By",

  // arrivalEta : "Factory Requested Arrival Time",
  // assignedTimeGap : "Time Gap",
  // arrivalConfTime :"Arrival Confirmation Date",
  // arrivalConfBy :"Arrival Confirmation By",
  // startArrivalUpdatedTime : "Updated Date/Time",
  // startDepartureUpdatedTime : "Updated Date/Time",
  // endArrivalUpdatedTime :  "Updated Date/Time",
  // endDepartureUpdatedTime : "Updated Date/Time",

  // timeGapRequestApproveAndArrivalEta : "Time Gap",
  // timeGapFirArrTimeUpdatedTimeAndFirstArrTime : "Time Gap",
  // timeGapFirDepTimeUpdatedTimeAndFirstDepTime : "Time Gap",
  // timeGapLastArrTimeUpdatedTimeAndLastArrTime : "Time Gap",
  // timeGapLastDepTimeUpdatedTimeAndLastDepTime : "Time Gap",
  // actionColumn : "Action",

  gReqCbm: "REQ CBM",
  gJobCbm: "JOB CBM",
  // gJobKmExpected: "Km Expected",
  kmActualValue: "Cargo in Hand",
  gChargeableKm: "Chargeable Km",
  gPlannedKm: "Planned Km",
  dedFuel: "Ded Fuel",
  jobConfirm: "Job Confirmation",
  // costInfo: "Cost Info",
  // financeInfo: "Finance Info",
  jobDocApproved: "Documents Approved",
  docApprovedDate: "Document Approved Date",
  jobDocUpload: "Job Doc Upload",
  gLocationStatus: "Time",
  Track: "Track",
  gStaName: "Current Status",
  reqDeliveryCutOffTime: "OTD Cutoff Time",
  gContactPerson: "Contact Person",
  reqParentRequestCode: "Parent Request",
  reqInvoiceRef: "Request Invoice Reference",
  jobAdditionalNo: "Job Additional Number",
  focStatus: "FOC",
  pickupDemurrageReason: "Pickup Demurrage Reason",
};

export const timeUpdateHeaderList = {
  gReqCode: "Request Id",
  gJobCode: "Job No",
  // gReqCustomer: "Customer",
  gReqBookingApprovalDate: "Shipment Approval Time",
  arrivalEta: "Factory Requested Arrival Time",
  timeGapRequestApproveAndArrivalEta: "Time Gap",
  gCreatedBy: "Shipment Creator",
  // gReqCustomer: "Customer",
  // gCreatedDate: "Date Created",
  // jobCreatedBy: "Job Created By",
  // jobCreatedDate: "Job Created Date",
  gReqPlant: "Requesting Plant",
  gVhtType: "Vehicle Type",
  vehVehicleno: "Vehicle No",
  gpsAvailability: "GPS Availability",
  gJobTransporter: "Transporter",
  gDriverName: "Driver Name",
  vehicleAssignedBy: "Assigned By",
  vehicleAssignedDate: "Assigned Date",
  assignedTimeGap: "Time Gap",
  arrivalConfTime: "Arrival Confirmation Date",
  arrivalConfBy: "Arrival Confirmation By",

  gFirstArrivalTime: "ARRD At Pickup Point",
  startArrivalUpdatedTime: "Updated Date/Time",
  timeGapFirArrTimeUpdatedTimeAndFirstArrTime: "Time Gap",
  startArrTimeUpdatedBy: "Updated By",

  gFirstDepatureTime: "DEP From Pickup point",
  startDepartureUpdatedTime: "Updated Date/Time",
  timeGapFirDepTimeUpdatedTimeAndFirstDepTime: "Time Gap",
  startDepTimeUpdatedBy: "Updated By",
  // gReqBookingApprovedBy: "Approved By",
  // gArrOnTime: "Arrival On Time",
  gLastArrivalTime: "ARRD At Delivery Point",
  endArrivalUpdatedTime: "Updated Date/Time",
  timeGapLastArrTimeUpdatedTimeAndLastArrTime: "Time Gap",
  endArrTimeUpdatedBy: "Updated By",

  gLastDepatureTime: "DEP From Delivery Point",
  endDepartureUpdatedTime: "Updated Date/Time",
  timeGapLastDepTimeUpdatedTimeAndLastDepTime: "Time Gap",
  endDepTimeUpdatedBy: "Updated By",
  // gDepOnTime: "Depature On Time",
  // startTimeGap: "Start Time Gap",
  // endTimeGap: "End Time Gap",
  actionColumn: "Action",
  gStaName: "Current Status",
};

export const chargePanelHeaderList = {
  gReqCode: "Request Id",
  gCreatedDate: "Date Created",
  gCreatedBy: "Shipment Creator",
  gReqCustomer: "Customer",
  gReqPlant: "Requesting Plant",
  vehVehicleno: "Vehicle",
  gVhtType: "Vehicle Type",
  totalRev: "Total Charge",
  transportRev: "Transport",
  demurrageRev: "Demmurage",
  nightParkRev: "Night Park",
  managementRev: "Management",
  fuelAdjRev: "Fuel Adjustment Fee",
  droppingPointRev: "Dropping Point Charges",
  unloadingRev: "Unloading Charges",
  loadUnloadRev: "Load/Unload",
  lashingRev: "Lashing Charges",
  highwayRev: "Highway Charges",
  tallyRev: "Tally Fee",
  boiRev: "BOI Charge",
  loadingRev: "Loading Charges",
  containerRev: "Container Charges",
  weighingRev: "Weighing Charges",
  discountRev: "Discount",
  otherRev: "Other",
  vehicleAssignedBy: "Assigned By",
  gFirstArrivalTime: "ARRD At Pickup Point",
  gFirstDepatureTime: "DEP From Pickup point",
  gLastArrivalTime: "ARRD At Delivery Point",
  gLastDepatureTime: "DEP From Delivery Point",
  gReqBillingCustomer: "Billing Customer",
  startLocation: "Start Location",
  arrivalEta: "Requested Arrival Time",
  viaLocations: "Via Locations",
  endLocation: "End Location",
  startContact: "Pickup Contact",
  endContact: "Delivery Contact",
  shipmentType: "Shipment Type",
  consignmentType: "Consignment Type",
  consignee: "Consignee",
  creatorRemark: "Creator Remark",
  kmActualValue: "Cargo in Hand",
  gPlannedKm: "Planned Km",
  gChargeableKm: "Chargeable Km",
  otherCharges: "Other Requests",
  jobConfirm: "Job Confirmation",
  gLocationStatus: "Time",
  Track: "Track",
  gStaName: "Current Status",
};

export const chargePanelColumnList = {
  gReqCode: { show: true, seq: 1, pinned: "left" }, // Request Id
  gCreatedDate: { show: true, seq: 2, pinned: "" }, // Date Created
  gCreatedBy: { show: true, seq: 3, pinned: "" }, // Shipment Creator
  gReqCustomer: { show: true, seq: 4, pinned: "" }, // Customer
  gReqPlant: { show: true, seq: 5, pinned: "" }, // Requesting Plant
  vehVehicleno: { show: true, seq: 6, pinned: "" }, // Vehicle
  gVhtType: { show: true, seq: 7, pinned: "" }, // Vehicle Type
  totalRev: { show: true, seq: 8, pinned: "" }, // TOTAL CHARGE
  transportRev: { show: true, seq: 9, pinned: "" }, // TRANSPORT
  demurrageRev: { show: true, seq: 10, pinned: "" }, // DEMMURAGE
  nightParkRev: { show: true, seq: 11, pinned: "" }, // NIGHT PARK
  managementRev: { show: true, seq: 12, pinned: "" }, // MANAGEMENT
  fuelAdjRev: { show: true, seq: 13, pinned: "" }, // FUEL ADJUSTMENT FEE
  droppingPointRev: { show: true, seq: 14, pinned: "" }, // DROPPING POINT CHARGES
  unloadingRev: { show: true, seq: 15, pinned: "" }, // UNLOADING CHARGES
  loadUnloadRev: { show: true, seq: 16, pinned: "" }, // LOAD/UNLOAD
  lashingRev: { show: true, seq: 17, pinned: "" }, // LASHING CHARGES
  highwayRev: { show: true, seq: 18, pinned: "" }, // HIGHWAY CHARGES
  tallyRev: { show: true, seq: 19, pinned: "" }, // TALLY FEE
  boiRev: { show: true, seq: 20, pinned: "" }, // BOI CHARGE
  loadingRev: { show: true, seq: 21, pinned: "" }, // LOADING CHARGES
  containerRev: { show: true, seq: 22, pinned: "" }, // CONTAINER CHARGES
  weighingRev: { show: true, seq: 23, pinned: "" }, // WEIGHING CHARGES
  discountRev: { show: true, seq: 24, pinned: "" }, // DISCOUNT
  otherRev: { show: true, seq: 25, pinned: "" }, // OTHER
  vehicleAssignedBy: { show: true, seq: 26, pinned: "" },
  gFirstArrivalTime: { show: true, seq: 27, pinned: "" },
  gFirstDepatureTime: { show: true, seq: 28, pinned: "" },
  gLastArrivalTime: { show: true, seq: 29, pinned: "" },
  gLastDepatureTime: { show: true, seq: 30, pinned: "" },
  gReqBillingCustomer: { show: true, seq: 31, pinned: "" },
  startLocation: { show: true, seq: 32, pinned: "" },
  arrivalEta: { show: true, seq: 33, pinned: "" },
  viaLocations: { show: true, seq: 34, pinned: "" },
  endLocation: { show: true, seq: 35, pinned: "" },
  startContact: { show: true, seq: 36, pinned: "" },
  endContact: { show: true, seq: 37, pinned: "" },
  shipmentType: { show: true, seq: 38, pinned: "" },
  consignmentType: { show: true, seq: 39, pinned: "" },
  consignee: { show: true, seq: 40, pinned: "" },
  creatorRemark: { show: true, seq: 41, pinned: "" },
  kmActualValue: { show: true, seq: 42, pinned: "" },
  gPlannedKm: { show: true, seq: 43, pinned: "" },
  gChargeableKm: { show: true, seq: 44, pinned: "" },
  otherCharges: { show: true, seq: 45, pinned: "" },
  jobConfirm: { show: true, seq: 46, pinned: "right" },
  gLocationStatus: { show: true, seq: 47, pinned: "right" },
  Track: { show: true, seq: 48, pinned: "right" },
  gStaName: { show: true, seq: 49, pinned: "right" },
};

export const jobMonitorColumnList = {
  gReqCode: { show: true, seq: 1, pinned: "left" }, // Request Id
  gJobCode: { show: true, seq: 2, pinned: "" }, // Job No
  gCreatedDate: { show: true, seq: 3, pinned: "" }, // Date Created
  creatorRemark: { show: true, seq: 4, pinned: "" },
  gReqCustomer: { show: true, seq: 5, pinned: "" },
  gReqInvoicingCustomer: { show: true, seq: 6, pinned: "" },
  gReqPlant: { show: true, seq: 7, pinned: "" },
  gJobTransporter: { show: true, seq: 8, pinned: "" },
  conMobile: { show: true, seq: 9, pinned: "" },
  gDriverName: { show: true, seq: 10, pinned: "" },
  gDrvPhoneNo: { show: true, seq: 11, pinned: "" },
  driverNic: { show: true, seq: 12, pinned: "" },
  vehicleAssignedBy: { show: true, seq: 13, pinned: "" },
  vehicleAssignedDate: { show: true, seq: 14, pinned: "" },
  gHelperName: { show: true, seq: 15, pinned: "" },
  gHelNicNo: { show: true, seq: 16, pinned: "" },
  gHelPhoneNo: { show: true, seq: 17, pinned: "" },
  jobVehAssignRemark: { show: true, seq: 18, pinned: "" },
  arrivalConfirmation: { show: true, seq: 19, pinned: "" },
  routeConfirmation: { show: true, seq: 20, pinned: "" },
  gLatestFlag: { show: true, seq: 21, pinned: "" }, // Flags
  otherCharges: { show: true, seq: 22, pinned: "" },
  supplierNego: { show: true, seq: 23, pinned: "" },
  customerNego: { show: true, seq: 24, pinned: "" },
  gVhtType: { show: true, seq: 25, pinned: "" },
  shipmentType: { show: true, seq: 26, pinned: "" },
  consignmentType: { show: true, seq: 27, pinned: "" },
  consignee: { show: true, seq: 28, pinned: "" },
  reqKagNoValue: { show: true, seq: 29, pinned: "" },
  startLocation: { show: true, seq: 30, pinned: "" },
  arrivalEta: { show: true, seq: 31, pinned: "" }, // ✅ Start Location ETA
  endLocation: { show: true, seq: 32, pinned: "" },
  deliveryEta: { show: true, seq: 33, pinned: "" }, // ✅ End Location ETA
  gReqBookingApprovedBy: { show: true, seq: 34, pinned: "" },
  gReqBookingApprovalDate: { show: true, seq: 35, pinned: "" },
  reference: { show: true, seq: 36, pinned: "" },
  gReqBillingCustomer: { show: true, seq: 37, pinned: "" },
  reqLateAccept: { show: true, seq: 38, pinned: "" },
  reqLateBooking: { show: true, seq: 39, pinned: "" },
  gCreatedBy: { show: true, seq: 40, pinned: "" }, // Shipment Creator
  behalfOfUser: { show: true, seq: 41, pinned: "" },
  reqPoNo: { show: true, seq: 42, pinned: "" },
  jobAod: { show: true, seq: 43, pinned: "" },
  jobSeal1: { show: true, seq: 44, pinned: "" },
  jobSeal2: { show: true, seq: 45, pinned: "" },
  jobSeal3: { show: true, seq: 46, pinned: "" },
  jobMoux: { show: true, seq: 47, pinned: "" },
  jobCarton: { show: true, seq: 48, pinned: "" },
  jobOperationRemark: { show: true, seq: 49, pinned: "" },
  jobCustomerFeedback: { show: true, seq: 50, pinned: "" },
  jobHeldUpRemark: { show: true, seq: 51, pinned: "" },
  gLatestRemark: { show: true, seq: 52, pinned: "" }, // Remarks
  gFirstArrivalTime: { show: true, seq: 53, pinned: "" }, // ARRD Pickup
  gFirstDepatureTime: { show: true, seq: 54, pinned: "" }, // DEP Pickup
  gLastArrivalTime: { show: true, seq: 55, pinned: "" }, // ARRD Delivery
  gLastDepatureTime: { show: true, seq: 56, pinned: "" }, // DEP Delivery
  gArrOnTime: { show: true, seq: 57, pinned: "" },
  gDepOnTime: { show: true, seq: 58, pinned: "" },
  gReqCbm: { show: true, seq: 59, pinned: "" },
  gJobCbm: { show: true, seq: 60, pinned: "" },
  kmDeviation: { show: true, seq: 61, pinned: "" },
  kmActualValue: { show: true, seq: 62, pinned: "" }, // Cargo in Hand
  gChargeableKm: { show: true, seq: 63, pinned: "" },
  gPlannedKm: { show: true, seq: 64, pinned: "" },
  dedFuel: { show: true, seq: 65, pinned: "" }, // Fuel Quota
  jobConfirm: { show: true, seq: 66, pinned: "" },
  jobDocApproved: { show: true, seq: 67, pinned: "" },
  docApprovedDate: { show: true, seq: 68, pinned: "" },
  jobDocUpload: { show: true, seq: 69, pinned: "" },
  jobCallCenterRemark: { show: true, seq: 70, pinned: "" },
  jobESeal: { show: true, seq: 71, pinned: "" },
  containerNumbers: { show: true, seq: 72, pinned: "right" },
  gJobVehicle: { show: true, seq: 73, pinned: "right" },
  gLocationStatus: { show: true, seq: 74, pinned: "right" },
  Track: { show: true, seq: 75, pinned: "right" },
  gStaName: { show: true, seq: 76, pinned: "right" },
  jobOtdRemark: { show: true, seq: 77, pinned: "" },
  reqDeliveryCutOffTime: { show: true, seq: 78, pinned: "" },
  gContactPerson: { show: true, seq: 79, pinned: "" },
  reqParentRequestCode: { show: true, seq: 80, pinned: "left" },
  reqInvoiceRef: { show: true, seq: 81, pinned: "" },
  jobAdditionalNo: { show: true, seq: 82, pinned: "" },
  focStatus: { show: true, seq: 83, pinned: "" },
  pickupDemurrageReason: { show: true, seq: 84, pinned: "" },
};

export const timeUpdateColumnList = {
  gReqCode: {
    show: true,
    seq: 1,
    pinned: "",
  },
  gJobCode: {
    show: true,
    seq: 2,
    pinned: "",
  },
  // gReqCustomer: {
  //   show: true,
  //   seq: 3,
  //   pinned: "",
  // },
  gReqBookingApprovalDate: {
    show: true,
    seq: 3,
    pinned: "",
  },
  arrivalEta: {
    show: true,
    seq: 4,
    pinned: "",
  },
  timeGapRequestApproveAndArrivalEta: {
    show: true,
    seq: 5,
    pinned: "",
  },
  gCreatedBy: {
    show: true,
    seq: 6,
    pinned: "",
  },
  gReqPlant: {
    show: true,
    seq: 7,
    pinned: "",
  },
  gVhtType: {
    show: true,
    seq: 8,
    pinned: "",
  },
  vehVehicleno: {
    show: true,
    seq: 9,
    pinned: "",
  },
  gpsAvailability: {
    show: true,
    seq: 10,
    pinned: "",
  },
  gJobTransporter: {
    show: true,
    seq: 11,
    pinned: "",
  },
  gDriverName: {
    show: true,
    seq: 12,
    pinned: "",
  },
  vehicleAssignedBy: {
    show: true,
    seq: 13,
    pinned: "",
  },
  vehicleAssignedDate: {
    show: true,
    seq: 14,
    pinned: "",
  },

  assignedTimeGap: {
    show: true,
    seq: 15,
    pinned: "",
  },
  arrivalConfTime: {
    show: true,
    seq: 16,
    pinned: "",
  },
  arrivalConfBy: {
    show: true,
    seq: 17,
    pinned: "",
  },

  gFirstArrivalTime: {
    show: true,
    seq: 18,
    pinned: "",
  },
  startArrivalUpdatedTime: {
    show: true,
    seq: 19,
    pinned: "",
  },
  timeGapFirArrTimeUpdatedTimeAndFirstArrTime: {
    show: true,
    seq: 20,
    pinned: "",
  },
  startArrTimeUpdatedBy: {
    show: true,
    seq: 21,
    pinned: "",
  },

  gFirstDepatureTime: {
    show: true,
    seq: 22,
    pinned: "",
  },
  startDepartureUpdatedTime: {
    show: true,
    seq: 23,
    pinned: "",
  },
  timeGapFirDepTimeUpdatedTimeAndFirstDepTime: {
    show: true,
    seq: 24,
    pinned: "",
  },
  startDepTimeUpdatedBy: {
    show: true,
    seq: 25,
    pinned: "",
  },

  gLastArrivalTime: {
    show: true,
    seq: 26,
    pinned: "",
  },
  endArrivalUpdatedTime: {
    show: true,
    seq: 27,
    pinned: "",
  },
  timeGapLastArrTimeUpdatedTimeAndLastArrTime: {
    show: true,
    seq: 28,
    pinned: "",
  },
  endArrTimeUpdatedBy: {
    show: true,
    seq: 29,
    pinned: "",
  },

  gLastDepatureTime: {
    show: true,
    seq: 30,
    pinned: "",
  },
  endDepartureUpdatedTime: {
    show: true,
    seq: 31,
    pinned: "",
  },
  timeGapLastDepTimeUpdatedTimeAndLastDepTime: {
    show: true,
    seq: 32,
    pinned: "",
  },
  endDepTimeUpdatedBy: {
    show: true,
    seq: 33,
    pinned: "",
  },
  actionColumn: {
    show: true,
    seq: 34,
    pinned: "",
  },
  gStaName: {
    show: true,
    seq: 35,
    pinned: "",
  },
};
